import { PureComponent } from 'react';
import { CANDY_APPLE, OLAF } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorIcon extends PureComponent {
  render() {
    const {
      className
    } = this.props;
    return /*#__PURE__*/_jsx(UIIconCircle, {
      backgroundColor: CANDY_APPLE,
      borderWidth: 0,
      className: className,
      color: OLAF,
      innerStyles: {
        lineHeight: 1
      },
      name: "warning",
      padding: 0.2,
      size: 10
    });
  }
}
ErrorIcon.defaultProps = {
  className: 'm-right-4'
};
export default ErrorIcon;